import React from 'react';
import {useAppSelector} from "../../lib/hooks";
import FileInputWeb from "./FileInputWeb";
import FileInputMobile from "./FileInputMobile";
import {InputProps} from "components/forms/Input";

export interface FileInputProps extends InputProps {
  accept?: string;
}

const FileInput: React.FC<FileInputProps> = (props) => {
  const deviceInfo = useAppSelector(state => state.app.deviceInfo);
  const isNative = deviceInfo?.platform !== 'web';

  if (!isNative) {
    return (
      <FileInputWeb
        {...props}
      />
    )
  } else {
    return (
      <FileInputMobile
        {...props}
      />
    )
  }
}

export default FileInput;
